<template>
	<div class="DiFangZhiList"><router-view></router-view></div>
</template>
<script>
export default {
	name: 'home',

	data() {
		return {
			search: ''
		};
	},
	mounted() {
		this.search = this.$route.query.q;
	},
	methods: {
		searchDiFangZhi() {
			const pageType = this.$route.query.type;
			this.$router.push({ path: 'DiFangZhi', query: { type: pageType, q: this.search } });
		}
	}
};
</script>
<style scoped>
.DiFangZhiList {
	width: 100%;
	    height: 100%;
}
</style>
